import { render, staticRenderFns } from "./SupplyPalletMirror.vue?vue&type=template&id=4539f0f0&v-slot%3Ano-data=true"
import script from "./SupplyPalletMirror.vue?vue&type=script&lang=js"
export * from "./SupplyPalletMirror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports